/* eslint-disable import/no-extraneous-dependencies,import/order,react/destructuring-assignment,eslint-disable-next-line react/destructuring-assignment */
import React from 'react';
import { Icon, Layout, Menu } from 'antd';
import { connect } from 'dva/index';
import router from 'umi/router';
import cls from 'classnames';
import RightContent from './Right';
import { Link } from 'umi';
import { handleUserAgent, callbackUrl } from '../../utils/utils';

import styles from './index.less';
import { title } from '../../defaultSettings';

class BasicsHeader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pathname: '',
      sloganUrl: '',
    };
  }

  componentDidMount () {
    this.handleShowSlogan();
  }

  handleShowSlogan = () => {
    const me = this;
    const historyName = callbackUrl(window.location.href);
    if (historyName) {
      const img = new Image();
      // 通过域名（x_xiaoyuanhao_com）解析成图片的名称 https://nbugs-front-end.oss-cn-hangzhou.aliyuncs.com/partners/x_xiaoyuanhao_com.png
      const sloganUrl = `https://nbugs-front-end.oss-cn-hangzhou.aliyuncs.com/partners/${historyName}.png`;
      // state中的sloganW为slogan的默认宽度
      img.onload = (info) => {
        me.setState({
          sloganUrl,
        })
      }
      img.src = sloganUrl;
    }
  }


  getFirstChildPath = pathItem => {
    const { children } = pathItem;
    if (!children || children.length === 0) {
      return pathItem.path;
    }
    return this.getFirstChildPath(children[0]);
  };

  handleChildrenClick = (childrenList, pathname) => {
    this.setState({
      pathname,
    });

    this.props.dispatch({
      type: 'global/save',
      payload: {
        childrenList,
      },
    });

    // 点击菜单后，自动跳转到第一个子项path
    if (childrenList.length) {
      const locaPath = this.getFirstChildPath(childrenList[0]);
      if (locaPath && locaPath.indexOf('http') === 0) {
        window.open(locaPath);
        return null;
      }
      router.push(locaPath);
    }
    return null;
  };

  handleMenuWork = menu => {
    const pathUrl = window.location.pathname.split('/') || '';

    // 默认选中header中的菜单
    if (!this.state.pathname && pathUrl && pathUrl.length > 2) {
      this.setState({
        pathname: `/${pathUrl[1]}`,
      });
    }

    if (handleUserAgent() && pathUrl && pathUrl.length > 2) {
      const resMenu = menu.filter(item => item.path === `/${pathUrl[1]}`) || [];
      if (resMenu && resMenu.length) {
        return [resMenu[0]];
      }
    }
    return menu;
  };

  handleMenuSelected = path => {
    const { pathname } = this.state || {};
    if (!path || !pathname) {
      return '';
    }
    return pathname === path || path.indexOf(pathname) === 0 ? 'ant-menu-item-selected' : '';
  };

  handleMenuCollapse = e => {
    const { dispatch, collapsed } = this.props;
    dispatch({
      type: 'global/changeLayoutCollapsed',
      payload: !collapsed,
    });
    e.stopPropagation();
  };

  render () {
    const { currentUser, menuData = [], collapsed } = this.props;
    const menuList = this.handleMenuWork(menuData);
    const { sloganUrl } = this.state

    return (
      <div className={styles['header-container']}>
        <Layout.Header>
          <div
            className={cls({
              [styles['header-container-item']]: true,
              [styles.collapsed]: collapsed,
            })}
          >
            <Icon
              style={{ color: 'white' }}
              type={collapsed ? 'menu-unfold' : 'menu-fold'}
              onClick={this.handleMenuCollapse}
            />
            {!collapsed && (
              <Link to="/">
                <span className={styles.span}>{currentUser.schoolName}</span>
                <h1 className="logo-h1">{title}</h1>
              </Link>
            )}
          </div>
          <Menu
            style={sloganUrl && sloganUrl.length ? { width: '58%' } : {}}
            theme="dark"
            mode="horizontal"
            defaultSelectedKeys={['2']}
          // overflowedIndicator={<Icon type="down" style={{ color: '#fff', fontSize: 11 }} />}
          >
            {menuList.map((item, index) => {
              return item.routeSign !== 'v2' ? (
                ''
              ) : (
                <Menu.Item
                  onClick={() => this.handleChildrenClick(item.children, item.path)}
                  className={this.handleMenuSelected(item.path)}
                  key={`${index}-key-menu`}
                >
                  {item.name}
                </Menu.Item>
              );
            })}
          </Menu>
          <RightContent {...this.props} sloganUrl={sloganUrl} />
        </Layout.Header>
      </div>
    );
  }
}

export default connect(({ user, global, setting, loading, selectSchool }) => ({
  currentUser: user.currentUser,
  collapsed: global.collapsed,
  fetchingMoreNotices: loading.effects['global/fetchMoreNotices'],
  fetchingNotices: loading.effects['global/fetchNotices'],
  notices: global.notices,
  setting,
  schools: selectSchool.schools,
}))(BasicsHeader);
